import { React, useState } from "react";
import { motion } from "framer-motion"; // For animations
import EngineeringData from "../data/EngineeringData";
import WhyEngineering from "../assets/why-engineering.png";
import "../styles/engineering.css";
import Footer from "../components/Footer";
import Call from "../components/Call";

function Engineering() {
  // Track expanded states per card
  const [expandedCards, setExpandedCards] = useState({});

  // Toggle function for individual cards
  const viewControl = (id) => {
    setExpandedCards((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle only the clicked card
    }));
  };

  return (
    <motion.div
      className="engineering-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Hero Section */}
      <motion.div
        className="engineering-hero"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h1>Our Engineering Services</h1>
        <p>
          At <span>NEXTCASTLE ENERGY LIMITED</span>, we deliver cutting-edge engineering solutions 
          tailored to the dynamic needs of the oil and gas industry. Our expertise spans conceptual 
          design, front-end engineering, detailed engineering, and project management, ensuring 
          seamless execution from inception to completion.
        </p>
      </motion.div>

      {/* Engineering Services Section */}
      <div className="engineering-services">
        <motion.div
          className="engineering-service-text"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Our Engineering Capabilities</h2>
        </motion.div>

        <div className="engineering-service-cards">
          {EngineeringData.map((item) => (
            <motion.div
              key={item.id}
              className="engineering-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <div className="engineering-card-image">
                <img src={item.picture} alt={item.title} />
              </div>
              <div className="engineering-card-text">
                <h2>{item.title}</h2>

                <motion.div
                  className="expanded-content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={expandedCards[item.id] ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {expandedCards[item.id] && <p>{item.description}</p>}
                </motion.div>

                <button onClick={() => viewControl(item.id)} className="view-more-btn">
                  {expandedCards[item.id] ? "<< See Less" : "See More >>"}
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="why-engineering-container">
        <motion.div
          className="why-engineering-image"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <img src={WhyEngineering} alt="nextcastle-why-choose-us" />
        </motion.div>

        <motion.div
          className="why-engineering-text"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <h2>Why Choose <span>NEXTCASTLE ENERGY LIMITED</span> for Engineering?</h2>
          <ul>
            <li><span> Expertise & Innovation:</span> We combine decades of engineering experience with the latest technology.</li>
            <li><span> Industry Compliance:</span> Our designs adhere to international safety and regulatory standards.</li>
            <li><span> Cost-Effective Solutions:</span> We optimize resources to deliver high-quality, cost-efficient engineering services.</li>
            <li><span> End-to-End Support:</span> From concept to execution, we provide complete engineering solutions.</li>
          </ul>
        </motion.div>
      </div>

      <Call />
      <Footer />
    </motion.div>
  );
}

export default Engineering;
